const drawerRight = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M10.49 1H1.06v1.57h9.43zm0 12.43H1.06V15h9.43zM16 8.05 11.45 3.5v3.72H.995v1.56H11.45v3.83z"/></svg>',
};

export { drawerRight as default };
